import { LinkOption } from 'app/interfaces';
import config from 'config/config';
import { SUPPORT_EMAIL } from './support-email';
import { AlternateEmail, OpenInNew as OpenInNewIcon } from '@mui/icons-material';

export const LINKS: LinkOption[] = [
  { label: 'Terms of Service', href: config?.termsOfUseUrl ?? '#', icon: OpenInNewIcon },
  {
    label: 'Tournament Rules',
    href: 'https://docs.okletsplay.com/legal/tournament-rules',
    icon: OpenInNewIcon,
  },
  { label: SUPPORT_EMAIL, href: `mailto:${SUPPORT_EMAIL}`, icon: AlternateEmail },
];
